export default __webpack_public_path__ + "static/media/3.9ea7d870.jpg";